<div class="container py-3">
  <h2 class="mb-3">Site Access</h2>

  <div class="card" *ngIf="!loading; else loadingTpl">
    <div class="card-body">
      <p class="text-muted">
        When public access is off, Login / Sign-up require a valid invite code or an existing local account email before Auth0.
      </p>

      <div class="form-check form-switch mb-3">
        <input class="form-check-input" type="checkbox" id="publicAccessToggle"
               [ngModel]="publicAccessEnabled"
               (ngModelChange)="onTogglePublic($event)" />
        <label class="form-check-label" for="publicAccessToggle">Public access enabled</label>
      </div>

      <div class="mb-3" style="max-width: 420px;">
        <label class="form-label">Invite code</label>
        <input class="form-control" type="text" [(ngModel)]="inviteCode" autocomplete="off" />
        <div class="form-text">Required (non-empty) to turn public access off. One shared code for the site.</div>
      </div>

      <div class="text-danger mb-3" *ngIf="validationError">{{ validationError }}</div>

      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!canSave">
        {{ saving ? 'Saving…' : 'Save' }}
      </button>

      <div class="text-muted mt-3 small" *ngIf="updatedAt || updatedBy">
        Last updated: {{ updatedAt || '—' }}
        <span *ngIf="updatedBy"> by {{ updatedBy }}</span>
      </div>
    </div>
  </div>

  <ng-template #loadingTpl>
    <div class="text-muted">Loading…</div>
  </ng-template>
</div>
